import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Row,
  Container,
  Label,
} from "reactstrap";
import ApiCaller from "api/apiCaller";
import { Transformation, TransformationListingResponse } from "model/transformation";

interface TransformationItemProps {
  transformationData: Transformation;
  companyName?: string;
}

export default function ScheduleQueryItem({
  transformationData,
  companyName,
}: TransformationItemProps) {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <a href={`/transformation/${transformationData?.id}`}>
            <span style={styles.name}>{transformationData?.name}</span>
          </a>
        </div>
        <span style={styles.projectName}>{companyName}</span>
      </div>
      <div style={styles.info}>
        {transformationData?.description &&
          <p style={styles.description}>{transformationData?.description}</p>
        }
        <span>Destination: {`${transformationData?.dataset_name}.${transformationData?.table_name}`}</span>
        <br />
      </div>
    </div>
  );
}

const styles: { [name: string]: React.CSSProperties } = {
  container: {
    padding: 12,
    border: "1px solid var(--color-line)",
    borderRadius: 4,
  },
  name: {
    fontSize: 18,
    fontWeight: 500,
  },
  description: {
    fontSize: 16,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  projectName: {
    fontSize: 16,
    padding: 6,
    color: "var(--color-accent-dark)",
    fontWeight: 500,
  },
  info: {
    fontSize: 14,
    color: "var(--secondary)",
  },
};
